export const locale = {
    lang: 'en',
    data: {
        PUBLIC_TOOLBAR: {
            TITLES: {
                PREPARED_FOR: 'Prepared for {{name}}',
                LISTINGS_SHARED: '{{count}} listings shared',
                LISTING_SHARED: '{{count}} listing shared',
                LOGIN: 'Login',
            }
        }
    }
};
